<div mat-dialog-title class="modal-header">
    <div class="d-inline-flex align-items-center">
        <mat-icon matSuffix svgIcon="total-fill-data" class="header-icon"></mat-icon>
        <h3>{{ 'pages.confirmThresholdDialog.title' | translate }}</h3>
    </div>
</div>

<div mat-dialog-content class="modal-content">
    <form [formGroup]="form">
        <p>
            {{ 'pages.confirmThresholdDialog.description' | translate }}
        </p>

        <mat-label><span
                class="red-color">* </span>{{ 'pages.confirmThresholdDialog.newMinimalThkLabel' | translate }}
        </mat-label>
        <mat-form-field appearance="outline" class="w-100 thickness-input">
            <input matInput type="number" formControlName="newMinimalThk"/>

            <mat-error *ngIf="form.get('newMinimalThk')?.hasError('mismatch')">
                {{ 'pages.confirmThresholdDialog.errorMismatch' | translate }}
            </mat-error>

            <mat-error *ngIf="form.get('newMinimalThk')?.hasError('required')">
                {{ 'pages.confirmThresholdDialog.errorRequired' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-card class="calculation-note-card">
            <mat-card-content>
                <div class="calculation-note">
                    <mat-icon class="calculation-note__icon">info</mat-icon>
                    <span class="fw-medium">
                            {{ 'pages.confirmThresholdDialog.calculationNote' | translate }}
                        </span>
                </div>
            </mat-card-content>
        </mat-card>

    </form>
</div>

<div mat-dialog-actions class="d-flex align-items-center justify-content-between gap-3">
    <button mat-button color="primary" (click)="onNotYet()" class="w-100" [disableRipple]="true">
        {{ 'pages.confirmThresholdDialog.notYetButton' | translate }}
    </button>

    <button mat-raised-button color="warn" (click)="onLeaveWithoutSaving()" class="w-100">
        {{ 'pages.confirmThresholdDialog.leaveWithoutSaving' | translate }}
    </button>

    <button
            mat-raised-button
            color="primary"
            [disabled]="form.invalid"
            (click)="onSave()"
            class="w-100"
    >
        {{ 'pages.confirmThresholdDialog.saveFilledData' | translate }}
    </button>
</div>
